import React from "react";

const VIMAAN_URL = "https://vimaan.ludoexchange.com/";

export default function Vimaan() {
  return (
    <main
      aria-label="Vimaan game"
      style={{ background: "#fff", height: "calc(100vh - 100px)", width: "100%" }}
    >
      <iframe
        title="Vimaan"
        src={VIMAAN_URL}
        allow="autoplay; fullscreen"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
        style={{ border: 0, display: "block", height: "100%", width: "100%" }}
      />
    </main>
  );
}
